import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ViewEResourceDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAttachment: null,
            selectedType: null,
        };
    }

    // Handle clicking on an attachment or URL
    handleAttachmentClick = (index, type) => {
        this.setState({
            selectedAttachment: index,
            selectedType: type || "attachment",
        });
    };

    // Close modal
    closeViewResourceModal = () => {
        this.setState({ selectedAttachment: null, selectedType: null });
        this.props.onClose?.(); // Optional external close
    };

    renderAttachmentList = () => {
        const { ResourceData } = this.props;
        const attachmentDetails = ResourceData?.attachmentDetails || [];
        const url = ResourceData?.URL;

        const listItems = [];

        // Attachment files
        if (Array.isArray(attachmentDetails) && attachmentDetails.length > 0) {
            attachmentDetails.forEach((file, index) => {
                const name = file?.attachmentFileName || "Attachment";
                listItems.push(
                    <li
                        key={index}
                        className="list-group-item attachmentNameListItem"
                        title={name}
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleAttachmentClick(index, "attachment")}
                    >
                        {name.length > 30 ? name.slice(0, 30) + "..." : name}
                    </li>
                );
            });
        }

        // URL option
        if (url) {
            listItems.push(
                <li
                    key="url"
                    className="list-group-item attachmentNameListItem"
                    title="URL"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.handleAttachmentClick(0, "url")}
                >
                    URL
                </li>
            );
        }

        return <ul className="list-group attachmentList">{listItems}</ul>;
    };

    renderAttachmentViewer = () => {
        const { ResourceData } = this.props;
        const { selectedAttachment, selectedType } = this.state;
        const attachmentDetails = ResourceData?.attachmentDetails || [];
        const url = ResourceData?.URL;

        if (!selectedType) {
            return <div>Kindly click on any one attachment</div>;
        }

        if (selectedType === "attachment") {
            const file = attachmentDetails[selectedAttachment];
            const src = file?.attachmentName;
            if (!src) return <div>No attachment found.</div>;

            return (
                <iframe
                    title="Attachment Viewer"
                    frameBorder="0"
                    style={{ width: "100%", height: "300%" }}
                    src={src}
                ></iframe>
            );
        }

        // For URL type
        let finalUrl = url || "";
        if (finalUrl && !finalUrl.includes("https://")) {
            finalUrl = "https://" + finalUrl;
        }

        return (
            <div>
                If you are unable to view content, then please{" "}
                <a href={finalUrl} target="_blank" rel="noopener noreferrer">
                    CLICK HERE
                </a>{" "}
                to open the URL in a new tab.
                <br />
                <iframe
                    title="Resource URL Viewer"
                    frameBorder="0"
                    style={{ width: "100%", height: "300%" }}
                    src={finalUrl}
                ></iframe>
            </div>
        );
    };

    render() {
        const { viewSingleResources } = this.props;

        return (
            <div
                className={viewSingleResources ? "modal fade show" : "modal fade"}
                id="modalContainer"
                style={{ display: viewSingleResources ? "block" : "none" }}
            >
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "70vw" }}>
                    <div className="modal-content">
                        {/* Header */}
                        <div className="modal-header" style={{ padding: "15px" }}>
                            <h6 class="modal-title text-white" style={{ fontWeight: 500, color: "#000000" }}>View Attachments</h6>
                            <FontAwesomeIcon
                                icon={['fas', 'times']}
                                size="sm"
                                onClick={this.closeViewResourceModal}
                                style={{ cursor: "pointer" }}
                            />
                        </div>

                        {/* Body */}
                        <div className="modal-body" style={{ maxHeight: "60vh", height: "75vh", overflowY: "auto" }}>
                            <div className="row">
                                {/* Left column: Attachment List */}
                                <div className="col-md-4">{this.renderAttachmentList()}</div>

                                {/* Right column: Viewer */}
                                <div className="col-md-8">{this.renderAttachmentViewer()}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ViewEResourceDetails;
